import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom"

import {
  Login,
  Companies,
  DashBoard,
  CreateItemMaster,
  ItemMaster,
  ResetPassword,
  CreateColorMaster,
  ColorMaster,
  PurityMaster,
  CreateShapeMaster,
  CreateAccountMaster,
  AccountMaster,
  CreateMemoEntry,
  MemoEntryMaster,
  CreatePurityMaster,
  ShapeMaster,
  CreateModeSetting,
  CreateInvoiceMaster,
  MemoFinalizeEntry,

} from "./pages/index.js"

import { decryptText, encryptText, linksUrl } from "./constants/enum.js"
import PrivateRoute from "./PrivateRoute.jsx"
import { SideNav, Nav, TokenExpired, ErrorCard } from "./components/index.js"
import { Drawer, IconButton } from "@mui/material"
import { faClosedCaptioning, faSquareXmark, faWarning } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { menuPages } from "./constants/menuPages.js"
import usePagesTitle from "./constants/pagesTitle.js"
import UseIdleLogout from "./components/UseIdleLogout.jsx"



//import Test from "./pages/sample/Test.jsx"

function App() {
  const location = useLocation()
  const { isAuthenticated,user, tokenExpiry, } = useSelector((state) => state.auth)
  const { compCode } = useSelector((state) => state.company)
  let navigate = useNavigate();

   UseIdleLogout(30);
  const [openDrawer, setOpenDrawer] = useState(false);
  if (tokenExpiry && tokenExpiry != "") {
    const currentTime = new Date().getTime() / 1000;
    let timeRemaining = tokenExpiry - currentTime

    if (currentTime > tokenExpiry) {
      if ( !toast.isActive('tknExpiremsg')  && !toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
        toast.error("Session Expired Login In Again...", {
          "position": "top-center",
          toastId: "tknExpire",
          onClose: () => navigate(linksUrl.login)
        })
      }
    }
    if (timeRemaining <= 600) {
      if (!toast.isActive('tknExpiremsg') && !toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
        toast.warning("Session Expired soon save your work ....", {
          "position": "top-center",
          toastId: "tknExpiremsg"
        })
      }
    }
  }
  useEffect(() => {
    if (!isAuthenticated)
      navigate(linksUrl.login)
    
      

    if (tokenExpiry && tokenExpiry != "") {
      const currentTime = new Date().getTime() / 1000;
      let timeRemaining = tokenExpiry - currentTime
      // if (timeRemaining <= 600) {
      //   toast.warning("Token Expire Wihin 5 Minutes save your work ....", {
      //     "position": "top-center"
      //   })
      // }

      if (currentTime > tokenExpiry) {
        // setOpenDrawer(true)
      }
    }
  }, [])


  const hanldeClick = () => {
    setOpenDrawer(false)
    navigate(linksUrl.login)
  }
  const pages = menuPages
  //console.log(encryptText("Sale"),"hfgh")
  //console.log(encryptText("Sale"),"hfgh")
  const shouldShowSidebar = () => {
    const { pathname } = location
    
    return !["/login", "/signup", "/sidenav"].includes(pathname) //when path incude this not showside bar
  }
  usePagesTitle();
  return (
    <div className="relative bg-gray-50">
      <Drawer open={openDrawer} anchor="top"  >
        <FontAwesomeIcon onClick={hanldeClick} className=" p-3 cursor-pointer text-blue-800 text-3xl absolute right-0" icon={faSquareXmark} />
        <div className="text-center font-semibold p-8 text-gray-800 border-2 border-b-gray-700">
          <FontAwesomeIcon className="text-rose-500" icon={faWarning} ></FontAwesomeIcon> Token Has Expired !
        </div>
      </Drawer>

      {shouldShowSidebar() && <Nav />}
      {shouldShowSidebar() && <SideNav />}


      {/* Routes */}

      <Routes>
        {/* Sample - to check ui*/}
        {/* ene of sample */}
        <Route
          path={linksUrl.login}
          element={
            !isAuthenticated ? <Login /> : <Navigate to={linksUrl.companies} />
          }
        />

        {/* private routes */}
        {/* 
          <Route
            path={linksUrl.dashboard}
            element={
              <PrivateRoute authorized={true}>
                <Dashboard />
              </PrivateRoute>
            }
          /> */}

        {pages.map((page, index) => {
          //if (page !== "report") {
          return (
            <Route
              target={"_blank"}
              key={index}
              path={page.path}
              element={
                <PrivateRoute page={page}>{page.component}</PrivateRoute>
              }
            />
          )
        })}
      </Routes>
      <div id="footer"></div>
    </div>
  )
}

export default App
